import React from 'react';
import { CHECKOUT_URL } from '../data/content';
import { trackLead } from '../utils/metaPixel';
type CheckoutButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  variant?: 'primary' | 'onDark';
  className?: string;
};
const sizes = {
  md: 'px-5 py-3 text-[0.95rem]',
  lg: 'px-7 py-4 text-lg sm:px-8 sm:text-xl'
};
const variants = {
  primary: 'bg-orangey-500 text-white hover:bg-orangey-700',
  onDark: 'bg-white text-orangey-700 hover:bg-orangey-50'
};

/**
 * Every checkout CTA on the page. Fires the Meta Pixel Lead event
 * immediately before the browser follows the link to checkout.
 */
export function CheckoutButton({
  children,
  size = 'lg',
  variant = 'primary',
  className = ''
}: CheckoutButtonProps) {
  return <a href={CHECKOUT_URL} onClick={() => trackLead()} className={`inline-flex items-center justify-center rounded-2xl font-display font-bold shadow-lift transition-all duration-200 hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-orangey-700 active:translate-y-0 ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-25" data-mp="14nsgpc7mctqv">
      {children}
    </a>;
}